module.exports = __webpack_public_path__ + "img/Group33.286dcd19.png";